module.exports = __webpack_public_path__ + "static/media/Revisteros.c80519ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Revisteros.jpg
// module id = 150
// module chunks = 0